import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import TransactionsListItem from './TransactionsListItem';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces.regular}px;
`;

const TransactionsList = ({ source, items, onUpdate, onDelete }) => (
  <StyledContainer>
    {items?.map(({ id, ...restProps }) => (
      <TransactionsListItem
        key={id}
        id={id}
        source={source}
        {...restProps}
        onUpdate={onUpdate({ id, ...restProps })}
        onDelete={onDelete({ id, ...restProps })}
      />
    ))}
  </StyledContainer>
);

TransactionsList.propTypes = {
  source: PropTypes.string,
  items: PropTypes.array,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
};

export default TransactionsList;
